import React from "react";
import { StyledSkeleton } from "./styledcartPage";

import {StyledSelectCompany} from "../../../components/public/purchase/cart/companyCards/styledCompanyCards"

const companyCardsSkeleton = () => {
  return (
    <StyledSelectCompany className="p-2 d-flex flex-column justify-content-space align-items-center">
        <StyledSkeleton width={20} height={10} className="align-self-end"/>
      <StyledSkeleton width="75%" height="50%" className="mx-auto"/>
      <StyledSkeleton width="75%" height={20} className="mx-auto"/>
    </StyledSelectCompany>
  );
};

export default companyCardsSkeleton;
